import styled from 'styled-components';

export const GinStepsState = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;

export const InvalidGinFormModalActions = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const InvalidGinFormModalActionsPrimary = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: ${({ theme }) => theme.spacing.md}px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
